module.exports = __webpack_public_path__ + "static/media/check-undone-dark.7bdc0d72.svg";